import React from 'react'
import Table from 'react-bootstrap/Table';
import social from "../assets/social.png"
import view from "../assets/view.png"
import del from "../assets/del.png"
import star from "../assets/star.png"
import edit from "../assets/edit.png"
import { MonitorData1 } from '../Info/Previewarray';
import pen from "../assets/pen.png"
import block from "../assets/block.png"

function MonitorTable() {
    return (<>
        <Table responsive className='table mt-5' style={{ background: "#fff" }}>
            <tbody style={{ backgroundColor: "#fff", position: 'relative' }}>
                <tr className='head_table ps-3' >

                    <td>
                        <p className='table_data' style={{ width: "180px" }}>Preview</p></td>
                    <td>
                        <p className='table_data2' style={{ width: "280px" }}>Asset Information</p>
                    </td>
                    <td>
                        <p className='table_data6' style={{ width: "280px" }}>Upload Information</p>

                    </td>
                    <td>
                        <p className='table_data5 ' style={{ width: "280px" }}>CC LICENCE INFORMATION</p>
                    </td>
                    <td>
                        <p className='table_data5 ' style={{ width: "150px" }} >LINKED</p>
                    </td>
                    <td>
                        <p className='table_data' >Actions</p>
                    </td>

                </tr>
                <tr style={{ height: "10px" }}></tr>
                <tr style={{ height: "10px" }}></tr>
                {MonitorData1.map((e) => {
                    return (<>
                        <tr style={{ border: "1px solid transparent" }}>
                            <td >
                                <img src={e.img} />
                            </td>
                            <td>
                                <div>
                                    <p className='monitor_text1 mt-3'>{e.one}</p>
                                    <p className='table_text2'>{e.two}</p>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <p className='monitor_text1 mt-3'>{e.three}</p>
                                    <p className='table_text2'>{e.four}</p>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex gap-2 align-items-center'>
                                    <img src={social} className="mt-3" />
                                    <div>
                                        <p className='monitor_text1 mt-3'>{e.five}</p>
                                        <p className='table_text2'>{e.six}</p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex gap-2 align-items-center'>
                                    <p className='monitor_number mt-3'>2</p>
                                    <div>
                                        <p className='monitor_text1 mt-3'>{e.seven}</p>
                                        <div className='d-flex gap-1'>
                                        <p className='table_text2' style={{textDecoration:"underline"}}>{e.eight}</p>
                                        <p className='table_text2'  style={{textDecoration:"underline"}}>{e.nine}</p>
                                        </div>
                                     
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className='d-flex gap-2 align-items-center mt-4'>
                                    <img src={block} />
                                    <img src={pen} />
                                    <img src={del} />
                                </div>
                            </td>
                        </tr>


                    </>)
                })}



            </tbody>
        </Table>





    </>

    )
}

export default MonitorTable
// import React from 'react'
// import Table from 'react-bootstrap/Table';
// import social from "../assets/social.png"
// import view from "../assets/view.png"
// import del from "../assets/del.png"
// import star from "../assets/star.png"
// import edit from "../assets/edit.png"
// import { MonitorData } from '../Info/Previewarray';
// import pen from "../assets/pen.png"
// import block from "../assets/block.png"

// function MonitorTable() {
//     return (<>
//         <Table responsive className='table mt-5' style={{ background: "#fff" }}>
//             <tbody style={{ backgroundColor: "#fff", position: 'relative' }}>
//                 <tr className='head_table ps-3' >

//                     <td>
//                         <p className='table_data'>Posted By</p></td>
//                     <td>
//                         <p className='table_data2'>Profile</p>
//                     </td>
//                     <td>
//                         <p className='table_data6'>Date Added</p>

//                     </td>
//                     <td>
//                         <p className='table_data5 ms-3'>Post</p>
//                     </td>
//                     <td>
//                         <p className='table_data'>Actions</p>
//                     </td>

//                 </tr>
//                 <tr style={{ height: "10px" }}></tr>
//                 <tr style={{ height: "10px" }}></tr>
//                 {MonitorData.map((e) => {
//                     return (<>
//                         <tr style={{ border: "1px solid transparent" }}>
//                             <td >
//                                 <div className='pt-2' >
//                                     <p className='table_text '>{e.num}</p>
//                                     <div className='d-flex align-items-center gap-2'>
//                                         <p className='table_link' style={{ color: "black" }}>{e.link}</p>
//                                         <img src={social} />
//                                     </div>
//                                 </div>
//                             </td>
//                             <td>
//                                 <p className='table_text '>{e.name}</p>
//                             </td>
//                             <td>
//                                 <div>
//                                     <p className='table_text'>{e.data}</p>
//                                     <p className='table_text2'>{e.dname}</p>
//                                 </div>
//                             </td>
//                             <td>
//                                 <img src={e.img} />
//                             </td>
//                             <td>
//                                 <div className='d-flex gap-2 align-items-center mt-4'>
//                                     <img src={block} />
//                                     <img src={pen} />
//                                     <img src={del} />
//                                 </div>
//                             </td>
//                         </tr>


//                     </>)
//                 })}
//                 {/* <tr className='head_table ps-3' >

//                     <td>
//                         <p className='table_data'>Posted By</p></td>
//                     <td>
//                         <p className='table_data2'>Profile</p>
//                     </td>
//                     <td>
//                         <p className='table_data6'>Date Added</p>

//                     </td>
//                     <td>
//                         <p className='table_data5'>Post</p>
//                     </td>
//                     <td>
//                         <p className='table_data'>Actions</p>
//                     </td>

//                 </tr>
//                 <tr style={{ height: "10px" }}></tr>
//                 <tr style={{ height: "10px" }}></tr>

//                 <tr style={{ border: "1px solid transparent" }}>
//                     <td>
//                         <p className='table_text'>#00019298812</p></td>
//                     <td>
//                         <img className='business-img' src={business} />
//                     </td>
//                     <td>
//                         <div>
//                             <p className='table_text'>02/09/2022</p>
//                             <p className='table_text2'>by Adam Person</p>
//                         </div>
//                     </td>
//                     <td>
//                         <p className='table_text'>Cube Adx</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>Added - 02/09/2022</p>
//                         <p className='table_text3'>Expire - 02/09/2023</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>106 Douers</p>
//                     </td>
//                     <td><p className='table_text'>Florida</p></td>
//                     <td>
//                         <p className='table_text'>Miami</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>32226</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>+1490300330</p>
//                     </td>
//                     <td>
//                         <div className='d-flex gap-1 mt-3'>
//                             <img src={view} />
//                             <img src={star} />
//                             <img src={edit} />
//                             <img src={del} />
//                         </div>
//                     </td>
//                 </tr>
//                 <tr style={{ border: "1px solid transparent" }}>

//                     <td>
//                         <p className='table_text'>#00019298812</p></td>
//                     <td>
//                         <img className='business-img' src={business} />
//                     </td>
//                     <td>
//                         <div>
//                             <p className='table_text'>02/09/2022</p>
//                             <p className='table_text2'>by Adam Person</p>
//                         </div>

//                     </td>
//                     <td>
//                         <p className='table_text'>Cube Adx</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>Added - 02/09/2022</p>
//                         <p className='table_text3'>Expire - 02/09/2023</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>106 Douers</p>
//                     </td>
//                     <td><p className='table_text'>Florida</p></td>
//                     <td>
//                         <p className='table_text'>Miami</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>32226</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>+1490300330</p>
//                     </td>
//                     <td>
//                         <div className='d-flex gap-1 mt-3'>
//                             <img src={view} />
//                             <img src={star} />
//                             <img src={edit} />
//                             <img src={del} />
//                         </div>
//                     </td>
//                 </tr>
//                 <tr style={{ border: "1px solid transparent" }}>

//                     <td>
//                         <p className='table_text'>#00019298812</p></td>
//                     <td>
//                         <img className='business-img' src={business} />
//                     </td>
//                     <td>
//                         <div>
//                             <p className='table_text'>02/09/2022</p>
//                             <p className='table_text2'>by Adam Person</p>
//                         </div>

//                     </td>
//                     <td>
//                         <p className='table_text'>Cube Adx</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>Added - 02/09/2022</p>
//                         <p className='table_text3'>Expire - 02/09/2023</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>106 Douers</p>
//                     </td>
//                     <td><p className='table_text'>Florida</p></td>
//                     <td>
//                         <p className='table_text'>Miami</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>32226</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>+1490300330</p>
//                     </td>
//                     <td>
//                         <div className='d-flex gap-1 mt-3'>
//                             <img src={view} />
//                             <img src={star} />
//                             <img src={edit} />
//                             <img src={del} />
//                         </div>
//                     </td>
//                 </tr>
//                 <tr style={{ border: "1px solid transparent" }}>

//                     <td>
//                         <p className='table_text'>#00019298812</p></td>
//                     <td>
//                         <img className='business-img' src={business} />
//                     </td>
//                     <td>
//                         <div>
//                             <p className='table_text'>02/09/2022</p>
//                             <p className='table_text2'>by Adam Person</p>
//                         </div>

//                     </td>
//                     <td>
//                         <p className='table_text'>Cube Adx</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>Added - 02/09/2022</p>
//                         <p className='table_text3'>Expire - 02/09/2023</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>106 Douers</p>
//                     </td>
//                     <td><p className='table_text'>Florida</p></td>
//                     <td>
//                         <p className='table_text'>Miami</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>32226</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>+1490300330</p>
//                     </td>
//                     <td>
//                         <div className='d-flex gap-1 mt-3'>
//                             <img src={view} />
//                             <img src={star} />
//                             <img src={edit} />
//                             <img src={del} />
//                         </div>
//                     </td>
//                 </tr>
//                 <tr style={{ border: "1px solid transparent" }}>

//                     <td>
//                         <p className='table_text'>#00019298812</p></td>
//                     <td>
//                         <img className='business-img' src={business} />
//                     </td>
//                     <td>
//                         <div>
//                             <p className='table_text'>02/09/2022</p>
//                             <p className='table_text2'>by Adam Person</p>
//                         </div>

//                     </td>
//                     <td>
//                         <p className='table_text'>Cube Adx</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>Added - 02/09/2022</p>
//                         <p className='table_text3'>Expire - 02/09/2023</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>106 Douers</p>
//                     </td>
//                     <td><p className='table_text'>Florida</p></td>
//                     <td>
//                         <p className='table_text'>Miami</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>32226</p>
//                     </td>
//                     <td>
//                         <p className='table_text'>+1490300330</p>
//                     </td>
//                     <td>
//                         <div className='d-flex gap-1 mt-3'>
//                             <img src={view} />
//                             <img src={star} />
//                             <img src={edit} />
//                             <img src={del} />
//                         </div>
//                     </td>
//                 </tr> */}


//             </tbody>
//         </Table>





//     </>

//     )
// }

// export default MonitorTable